import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { right } from '@popperjs/core';
import {
  AccessPermissionService,
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  DISTANCE_KM_LABEL,
  grid_widths_map,
} from '@piqet-angular/shared';
import { ProjectsFacade } from '@piqet-angular/data';
import { NumericCellEditor } from 'libs/ui/src/lib/numeri-cell-editor/numeric-cell-editor.component';
import { cloneDeep } from 'lodash';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { Subject, take } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root',
})
export class ProjectScenarioWholesaleDataGridService {
  event: any;
  activatedRoute: any;
  deleteWholesale = new Subject<[any]>();
  deleteWholesaleData$ = this.deleteWholesale.asObservable();

  editWholesaleSuccess = new Subject<any>();
  editWholesaleSuccessData$ = this.editWholesaleSuccess.asObservable();

  inlineEditing = new Subject<any>();
  inlineEditingObservable$ = this.inlineEditing.asObservable();

  editProjectWholesaleSub = new Subject<[any, any]>();
  editProjectWholesaleSubData$ = this.editProjectWholesaleSub.asObservable();

  checkDeleteRowWholesale = new Subject<[any, any, boolean]>();
  checkDeleteRowWholesaleData$ = this.checkDeleteRowWholesale.asObservable();

  saveProjectManualDistanceWholesaleRetail = new Subject<[any, any]>();
  saveProjectManualDistanceWholesaleData$ =
    this.saveProjectManualDistanceWholesaleRetail.asObservable();

  clearInputFieldProjectManualDistanceWholesale = new Subject<any>();
  clearInputFieldProjectManualDistanceWholesaleData$ =
    this.clearInputFieldProjectManualDistanceWholesale.asObservable();

  allTransportLocationRecords: any;

  constructor(
    private projectsFacade: ProjectsFacade,
    private swalService: SwalService,
    private projectFacade: ProjectsFacade,
    private accessService: AccessPermissionService,
    private route: ActivatedRoute,
    private toaster: ToastrService
  ) {
    this.activatedRoute = this.route.snapshot.routeConfig?.path;
  }
  projectScenarioWholesalePayload: any;

  accessPermission(): boolean {
    return this.accessService.hasPermission('edit', '', 'packaging');
  }

  projectScenarioWholesaleData(): ColDef[] {
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'StorageProcessname',
      headerName: 'Storage process',
      field: 'storageProcessname',
      cellStyle: { 'text-decoration': 'underline' },
      // sort: 'desc',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      wrapHeaderText: true,
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.style.cursor = 'pointer';
        cellElement.innerHTML = `${cellValue}`;
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          this.projectsFacade.openNewAddProjectWholesaleData(
            params.data.scenarioId,
            params.data.id,
            1,
            'Review wholesale',
            params.data.projectId
          );
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'StorageDays',
      headerName: 'Storage days',
      field: 'storageDays',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      wrapHeaderText: true,
      editable: this.accessPermission(),
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'storageDays') {
          return {
            component: NumericCellEditor,
          };
        }
        return undefined;
      },
      cellRenderer: (params: any) => {
        return (
          '<span class="editable-icon project-inline-setWidth" >' +
          params.value +
          '<i class="fa fa-pencil icon-opacity" aria-hidden="true"></i></span>'
        );
      },
      cellEditorParams: {
        from: 'project-pages-inline',
      },
      cellClass: ['outerGridEdit', 'elipsisFields'],
      valueSetter: (params: any) => {
        const valueChanged = params.data[params.colDef.field] !== params.newValue;
        const oldValue = params.data[params.colDef.field];
        const newVal = params.newValue == 0 ? oldValue : params.newValue;
        if (params.newValue == 0) return;
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        const field = params.colDef.field;
        const nodeId = params.data.id;
        const inlineObject = {
          entityId: 'id',
          entityIdValue: params.data['id'],
          entityColumnName: params.colDef.field,
          filter: 'agTextColumnFilter',
          entityColumnValue: params.data[params.colDef.field],
        };
        if (!this.isEmpty(newVal) && valueChanged) {
          this.inlineEditing.next(inlineObject);
          return valueChanged;
        } else {
          this.toaster.error('Storage days are required');
          return oldValue;
        }
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'PercentageProductLoss',
      headerName: 'Product loss (%)',
      field: 'percentageProductLoss',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      wrapHeaderText: true,
      lockVisible: false,
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ProductLossName',
      headerName: 'Destination of product loss',
      field: 'productLossName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      wrapHeaderText: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'EndofLifeIdentifierName',
      headerName: 'Destination of packaging waste',
      field: 'endofLifeIdentifierName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      wrapHeaderText: true,
      lockVisible: false,
      resizable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'TransportToWholesale',
      headerName: 'Transport to wholesale',
      field: 'transportToWholesale',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      cellRenderer: 'iconsOfTransport',
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      wrapHeaderText: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'RegionName',
      headerName: 'Destination',
      field: 'regionName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
    });

    this.accessPermission() &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        maxWidth: grid_widths_map.sm_column_xs,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        cellRendererParams: {
          showEdit: true,
          showDelete: true,
          value: 'manageTeams',
          deleteData: (data: any) => {
            this.deleteConfirmation(data);
          },
          editData: (data: any) => {
            this.projectsFacade.openNewAddProjectWholesaleData(
              data.scenarioId,
              data.id,
              1,
              'Review wholesale',
              data.projectId
            );
          },
        },
        lockVisible: false,
        lockPosition: right,
        resizable: false,
      });

    return colDef;
  }

  getPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.projectScenarioWholesaleData()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.projectScenarioWholesalePayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'StorageProcessname',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Desc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }

  locationColumn(): ColDef[] {
    // For filling process section inside add Modal
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'OriginName',
      headerName: 'Location',
      field: 'originName',
      minWidth: grid_widths_map.sm_column_xl,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'TransportModeName',
      headerName: 'Transport mode',
      field: 'transportModeName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
      cellRenderer: 'linkRenderer',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'persanteageMassLoad',
      headerName: 'Load efficiency',
      field: 'persanteageMassLoad',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: false,
      hide: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Distance',
      headerName: DISTANCE_KM_LABEL,
      field: 'distance',
      // cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: true,
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'Distance') {
          return {
            component: NumericCellEditor,
          };
        }
        return undefined;
      },
      cellEditorParams: {
        isCheckTransportDistance: true,
        from: 'project-pages-inline',
      },
      cellStyle: params => {
        const isCellEditable = params.rowIndex == 0 ? false : true;
        return {
          'pointer-events': isCellEditable ? '' : 'none',
        };
      },
      cellClass: ['outerGridEdit', 'outerGridProjectEdit', 'elipsisFields'],
      valueSetter: (params: any) => {
        const oldValue = params.data[params.colDef.field];
        const getDisType = oldValue.substring(oldValue.indexOf(' ') + 1);
        const newVal = params.newValue + ' ' + (getDisType == '0' ? ' ' : getDisType);
        const valueChanged = params.data[params.colDef.field] !== newVal;
        params = cloneDeep(params);
        params = cloneDeep(params);
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
        }
        if (!this.isEmpty(newVal) && valueChanged) {
          this.projectFacade.locationProcessWholesaleActions(params.data, 'edit');
          this.editProjectWholesaleSub.next([params.data, false]);
          return valueChanged;
        } else {
          return oldValue;
        }
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      cellRendererParams: {
        showInlineEdit: true,
        showInlineDelete: true,
        from: 'projectPages',
        editDataInline: (data: any, pathName: any) => {
          data.isCheckManualDis
            ? this.projectFacade.distanceWholesaleActions(data, 'edit', false)
            : this.projectFacade.locationProcessWholesaleActions(data, 'edit');
          this.editProjectWholesaleSub.next([data, true]);
        },
        deleteInlineGrid: (data: any) => {
          if (!!data?.isDistance) {
            this.alertConfirmationForManualDistance(data);
          } else {
            this.alertConfirmationForManualLocation(data);
          }
        },
        saveDataInline: (data: any) => {
          this.saveProjectManualDistanceWholesaleRetail.next([data, 'manualLocation']);
        },
        clearInputField: (data: any) => {
          this.clearInputFieldProjectManualDistanceWholesale.next(data);
        },
      },
      maxWidth: grid_widths_map.sm_column_xs,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'inlineActionButtonComponent',
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });
    return colDef;
  }

  customSiteTransportColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'CityName',
      headerName: 'Origin-destination',
      field: 'cityName',
      minWidth: grid_widths_map.sm_column_xl,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'GridMyProjectImageComponent',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'TransportModeName',
      headerName: 'Transport mode',
      field: 'transportModeName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
      cellRenderer: 'linkRenderer',
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Distance',
      headerName: DISTANCE_KM_LABEL,
      field: 'distance',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      editable: false,
    });

    return colDef;
  }

  alertConfirmationForManualLocation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.projectFacade.locationWholesale$.pipe(take(1)).subscribe((records: any) => {
          this.allTransportLocationRecords = records;
        });
        this.projectsFacade.locationProcessWholesaleActions(data, 'delete');
        this.checkDeleteRowWholesale.next([this.allTransportLocationRecords, data, true]);
      }
    });
  }

  alertConfirmationForManualDistance(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.projectsFacade.distanceWholesaleActions(data, 'delete');
        this.checkDeleteRowWholesale.next([undefined, data, false]);
      }
    });
  }

  deleteConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteWholesale.next([data]);
      }
    });
  }

  getWholesaleDataList() {
    this.editWholesaleSuccess.next(() => {});
  }

  isEmpty(val: any) {
    val = val.toString();
    if (val !== undefined || val !== null || val !== '') {
      val = val.trim();
    }
    return val === undefined || val === null || val === '';
  }
}
